import { render } from "./FarmerDisplay.vue?vue&type=template&id=0db88d02&scoped=true&ts=true"
import script from "./FarmerDisplay.vue?vue&type=script&lang=ts"
export * from "./FarmerDisplay.vue?vue&type=script&lang=ts"

import "./FarmerDisplay.vue?vue&type=style&index=0&id=0db88d02&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db88d02"]])

export default __exports__